<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-visible-menu':state.visibleMenu},
    {'is-visible-menu-left':state.visibleMenuLeft}
    ]"
  >
  <BackgroundImage />
  

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="state.visibleMenu"
      @closeMenu="state.visibleMenu = false"
    />

    <div id="wrapper">

      <div id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-2"
          @click="state.visibleMenu = true;state.visibleWindowDetail = false"
        >
          <IconMenu class="icn" />
        </div>
      </div>
      
      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <div class="header-title">
            <h1>新規契約申し込みの完了</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-container">
            
            <div id="content">
              <div class="contact">
                <div class="contact-head">
                  <div class="breadcrumb">
                    <span class="breadcrumb-link">新規契約申し込み</span>
                    <span class="breadcrumb-link">新規契約申し込み内容の確認</span>
                    <span class="breadcrumb-link current">新規契約申し込みの完了</span>
                  </div>
                </div>
                <div class="contact-container">
                  <div class="contact-content">
                    <p class="txt mb20">本契約のお申し込みを完了しました。</p>

                    <div class="contact-submit mb40">
                      <div class="button contact-submit-button">
                        <router-link class="btn" to="/sp/contract">契約情報画面へ</router-link>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>


    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import SPMenu from '@/components/sp/popup/SPMenu.vue'
import * as LoggedinNewApplication from '@/logic/new-application/LoggedinNewApplication'

export default defineComponent({
  components: {
    SPMenu
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = LoggedinNewApplication.getGroupComplete()

    const state = reactive({
      visibleMenu: false
    })

    return {
      group1,
      state
    }
  }
})
</script>

<style lang="scss" scoped>
.contact-container {
  padding-bottom: 0;
}
</style>
